import React from 'react';
import { CheckCircle2Icon, FileSignatureIcon, GlobeIcon, MegaphoneIcon, MessageCircleIcon, PhoneMissedIcon, SendIcon, StarIcon, TargetIcon } from 'lucide-react';
import type { JourneyStage } from '../../data/crm';
type JourneyIllustrationProps = {
  stage: JourneyStage['id'];
};
const card = 'rounded-xl border border-gray-200 bg-white p-4 shadow-sm';
export function JourneyIllustration({
  stage
}: JourneyIllustrationProps) {
  return <div className="flex h-full min-h-[320px] flex-col justify-center gap-3 rounded-2xl bg-brand-light p-6" aria-hidden="true" data-id="element-197" data-mp="iuy6zgtbgi36">
      {stage === 'capture' && <>
          {[{
        icon: PhoneMissedIcon,
        label: 'Missed call',
        detail: 'Text-back sent in 5 sec'
      }, {
        icon: GlobeIcon,
        label: 'Website form',
        detail: 'Quote request — water heater'
      }, {
        icon: MessageCircleIcon,
        label: 'Instagram DM',
        detail: '“Do you have openings Sat?”'
      }, {
        icon: TargetIcon,
        label: 'Google ad lead',
        detail: 'Added to pipeline'
      }].map(item => <div key={item.label} className={`${card} flex items-center gap-3`} data-id="element-198" data-mp="2c932hqy6md0q">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-tint text-brand-red" data-id="element-199" data-mp="2866nea7uoz1j">
                <item.icon className="h-4 w-4" data-id="element-200" data-mp="23cbv4ie6jbqu" />
              </span>
              <span className="flex-1" data-id="element-201" data-mp="1yf29ldtwvk8a">
                <span className="block text-xs font-bold text-brand-black" data-id="element-202" data-mp="1tgh7f8v3mqh7">{item.label}</span>
                <span className="block text-xs text-brand-gray" data-id="element-203" data-mp="1te4j8dyqzjvp">{item.detail}</span>
              </span>
              <span className="rounded bg-brand-red px-2 py-0.5 text-[10px] font-bold text-white" data-id="element-204" data-mp="1kfsu6gdj4u5d">New</span>
            </div>)}
        </>}

      {stage === 'nurture' && <div className={`${card} space-y-3`} data-id="element-205" data-mp="1fj2dprxtbwjf">
          <p className="text-xs font-bold text-brand-black" data-id="element-206" data-mp="3essf8p0oigk1">Automated follow-up</p>
          <p className="max-w-[80%] rounded-2xl rounded-bl-md bg-brand-light px-3 py-2 text-xs text-brand-black" data-id="element-207" data-mp="39u7feqpc9yw4">
            Hi Maria! Thanks for reaching out about a cleaning. Want to grab a time this week?
          </p>
          <p className="text-[10px] text-brand-gray" data-id="element-208" data-mp="1lpw3fduor6t">Sent instantly · Day 1</p>
          <p className="ml-auto max-w-[70%] rounded-2xl rounded-br-md bg-brand-red px-3 py-2 text-xs text-white" data-id="element-209" data-mp="3jz78inhixg7m">
            Yes! Thursday afternoon?
          </p>
          <p className="max-w-[80%] rounded-2xl rounded-bl-md bg-brand-light px-3 py-2 text-xs text-brand-black" data-id="element-210" data-mp="3ove5vrvutjdy">
            You’re booked for Thu at 3:00 PM. We’ll send a reminder the day before.
          </p>
          <div className="flex items-center gap-2 border-t border-gray-100 pt-3 text-xs font-semibold text-brand-black" data-id="element-211" data-mp="6jrh45uu70kx">
            <CheckCircle2Icon className="h-4 w-4 text-brand-red" data-id="element-212" data-mp="bi2rchp1nd3o" /> Appointment booked by AI
          </div>
        </div>}

      {stage === 'close' && <>
          <div className={card} data-id="element-213" data-mp="2w939yuj706nh">
            <div className="flex items-center justify-between" data-id="element-214" data-mp="2w9cx8acurzph">
              <span className="flex items-center gap-2 text-xs font-bold text-brand-black" data-id="element-215" data-mp="2opk54y6vh8lc">
                <FileSignatureIcon className="h-4 w-4 text-brand-red" data-id="element-216" data-mp="2orequepyx4qh" /> Estimate #1042
              </span>
              <span className="rounded bg-brand-light px-2 py-0.5 text-[10px] font-semibold text-brand-black" data-id="element-217" data-mp="2xq9x1qt0iets">Signed</span>
            </div>
            <div className="mt-4 space-y-2 text-xs text-brand-gray" data-id="element-218" data-mp="2ss8ed6zi0hiu">
              <div className="flex justify-between" data-id="element-219" data-mp="251bdcp98r4md"><span data-id="element-220" data-mp="252e6z4xy7l5z">Roof repair — labor</span><span data-id="element-221" data-mp="24zi3z278u6ao">$1,800</span></div>
              <div className="flex justify-between" data-id="element-222" data-mp="210j3btsjovp1"><span data-id="element-223" data-mp="211kj2bkia6d3">Materials</span><span data-id="element-224" data-mp="20xwqbemvxnzf">$650</span></div>
              <div className="flex justify-between border-t border-gray-100 pt-2 font-bold text-brand-black" data-id="element-225" data-mp="2erxref1b7n2y"><span data-id="element-226" data-mp="2a05xbuiy2z82">Total</span><span data-id="element-227" data-mp="29zmpx7qx7t8a">$2,450</span></div>
            </div>
          </div>
          <div className={`${card} flex items-center gap-3`} data-id="element-228" data-mp="1matpaxzcsx7c">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-red text-white" data-id="element-229" data-mp="1m9abde166y8q">
              <CheckCircle2Icon className="h-4 w-4" data-id="element-230" data-mp="1h9xmyounhj41" />
            </span>
            <span data-id="element-231" data-mp="1v0ag0glcyuv2">
              <span className="block text-xs font-bold text-brand-black" data-id="element-232" data-mp="1uwmlbe46g2er">Deposit paid by text</span>
              <span className="block text-xs text-brand-gray" data-id="element-233" data-mp="1zvpsb43pwipd">Job locked in for Monday</span>
            </span>
          </div>
        </>}

      {stage === 'evangelize' && <>
          <div className={card} data-id="element-234" data-mp="29oy8uf3tkqhb">
            <div className="flex gap-0.5 text-brand-red" data-id="element-235" data-mp="2dph1uchg82l3">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-236" data-mp="2io1unqudfjzi" />)}
            </div>
            <p className="mt-2 text-xs leading-relaxed text-brand-black" data-id="element-237" data-mp="2nmv6zfxx94y3">“Showed up on time, fixed it fast, and the price was exactly what they quoted.”</p>
            <div className="mt-3 rounded-lg bg-brand-light p-3 text-xs text-brand-gray" data-id="element-238" data-mp="2slpwf0qe9rr6">
              <span className="font-bold text-brand-black" data-id="element-239" data-mp="taydzijtzr0x">Your reply:</span> Thank you so much! We’re glad we could help — see you next season.
            </div>
          </div>
          <div className={`${card} flex items-center gap-3`} data-id="element-240" data-mp="3bjrqncc4mo3v">
            <SendIcon className="h-4 w-4 text-brand-red" data-id="element-241" data-mp="36s9rmttnyxlj" />
            <span className="text-xs font-semibold text-brand-black" data-id="element-242" data-mp="36qqal106oiip">Shared to your Facebook & Instagram</span>
          </div>
        </>}

      {stage === 'reactivate' && <div className={card} data-id="element-243" data-mp="2xsmnw1dgpfpb">
          <div className="flex items-center gap-2" data-id="element-244" data-mp="2xp8n2xkg5ejz">
            <MegaphoneIcon className="h-4 w-4 text-brand-red" data-id="element-245" data-mp="3uhvmx66x0so9" />
            <p className="text-xs font-bold text-brand-black" data-id="element-246" data-mp="3qg0oc9gdcte6">Spring Tune-Up Campaign</p>
          </div>
          <div className="mt-4 space-y-2 text-xs" data-id="element-247" data-mp="3lgxm0wrrx19w">
            <div className="flex justify-between rounded-md bg-brand-light px-3 py-2" data-id="element-248" data-mp="3lfcnkw2c8y6r">
              <span className="text-brand-gray" data-id="element-249" data-mp="3gh1e4mfygpp2">Audience</span>
              <span className="font-semibold text-brand-black" data-id="element-250" data-mp="2a1hbjw6qd5jr">Last visit 6+ months ago</span>
            </div>
            <div className="flex justify-between rounded-md bg-brand-light px-3 py-2" data-id="element-251" data-mp="2524nj844hsfl">
              <span className="text-brand-gray" data-id="element-252" data-mp="26k31x30ibc6d">Channels</span>
              <span className="font-semibold text-brand-black" data-id="element-253" data-mp="26hqkcqynv3tu">Text + Email</span>
            </div>
          </div>
          <p className="mt-4 rounded-2xl rounded-bl-md bg-brand-light px-3 py-2 text-xs text-brand-black" data-id="element-254" data-mp="2bgjy8khv0wuj">
            It’s been a while! Book your spring tune-up this month and get 15% off.
          </p>
          <p className="mt-3 flex items-center gap-2 text-xs font-semibold text-brand-black" data-id="element-255" data-mp="1ntbuw83zrxv5">
            <CheckCircle2Icon className="h-4 w-4 text-brand-red" data-id="element-256" data-mp="1nrikqiu66vie" /> Scheduled for Monday, 9:00 AM
          </p>
        </div>}
    </div>;
}